<template>
  <!--  Generated from Add_Edit_w_Lookups template-->
  <v-form ref="form" @submit.prevent lazy-validation v-model="valid">
    <v-card class="elevation-3">
      <v-card-title class="primary text-h5 white--text">
        {{ headerText }}
      </v-card-title>
      <v-card-text class="pa-4">
        <v-row>
          <v-col cols="12">
            <v-text-field
              label="Description"
              v-model="selectedLuAgencyDivision.Description"
              :rules="[(v) => !!v || 'required']"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-checkbox
              label="Is Active"
              v-model="selectedLuAgencyDivision.IsActive"
              :rules="[(v) => v === true || v === false || 'required']"
            ></v-checkbox>
          </v-col>
        </v-row>
        <!-- <v-row>
            <v-col cols="12">
              <LuAgency
                label="Agency"
                v-model="selectedLuAgencyDivision.AgencyId"
                  :rules="[v => !!v || 'required']"
              ></LuAgency>
            </v-col>
          </v-row> -->
        <!-- TrackedBillDivisions Join Items-->
        <!-- <v-row>
            <v-col cols="12">
              <TrackedBill
                label="Tracked Bill"
                v-model="selectedLuAgencyDivision.TrackedBillDivisions"
                selfKey="DivisionId"
                :selfId="selectedLuAgencyDivision.Id"
                relatedItemKey="TrackedBillId"
                joinItemName="TrackedBillDivision"
              ></TrackedBill>
            </v-col>
          </v-row> -->
      </v-card-text>
      <v-card-actions>
        <v-btn
          @click="saveLuAgencyDivisionDetails"
          :disabled="saving"
          color="primary"
          >Save</v-btn
        >
        <v-btn v-if="inDialog" outlined color="primary" @click="cancelEntry"
          >Cancel</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuAgencyDivision from '@classes/LuAgencyDivision'
//templateTODO: import lookup components you plan to use
//import TrackedBill from '@components/select/TrackedBill/TrackedBill-multi-join'
export default {
  components: {
    //templateTodo: define lookup components you are using
    //TrackedBill
  },
  props: {
    dialog: {
      type: Boolean,
      default: null,
    },
    agency: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    valid: true,
    selectedLuAgencyDivision: new LuAgencyDivision(),
    headerText: 'LuAgencyDivision',
  }),
  created() {},
  computed: {
    ...get('luAgencyDivision', ['saving']),
    inDialog() {
      if (this.dialog === false || this.dialog === true) {
        return true
      } else {
        return false
      }
    },
  },
  methods: {
    ...call('luAgencyDivision', ['saveLuAgencyDivision']),
    async validate() {
      await this.$refs.form.validate()
    },
    editLuAgencyDivision(entry) {
      this.selectedLuAgencyDivision = new LuAgencyDivision(entry)
      this.headerText = 'Edit Agency Division'
    },
    addLuAgencyDivision() {
      this.headerText = 'Insert Agency Division'
      this.selectedLuAgencyDivision = new LuAgencyDivision({AgencyId: this.agency})
    },
    async saveLuAgencyDivisionDetails() {
      await this.validate()
      if (this.valid) {
        //templateTODO: if you want to save related item arrays you will need to add a getSaveData() function to the javascript class and call that instead
        try {
          let res = await this.saveLuAgencyDivision(
            this.selectedLuAgencyDivision.removeRelated()
          )
          this.$emit('refresh')
          this.$emit('itemAdded', res.data)
          this.selectedLuAgencyDivision = new LuAgencyDivision()
          this.$refs.form.resetValidation()
        } catch (err) {}
        this.$emit('update:dialog', false)
      }
    },
    cancelEntry() {
      this.selectedLuAgencyDivision = new LuAgencyDivision()
      this.$refs.form.resetValidation()
      this.$emit('update:dialog', false)
    },
  },
}
</script>
<style></style>
